import { createContext } from "react";
/**
 * Allows access to current layout cell data at the current level
 */
export const LayoutRowContext = createContext({
    id: "",
    cells: [],
});
LayoutRowContext.displayName = "LayoutRowContext";
//# sourceMappingURL=LayoutRowContext.js.map